import React from 'react';

function DataTHs({ sumDs }) {
    if (!sumDs) return null;
    const { dataClass, valView, variView, okNgView } = sumDs;
    return (
        <React.Fragment>
            {
                dataClass.map((dataCls, idx) => {
                    const hasVari = variView[idx];
                    const colAmount = hasVari.reduce((prev, cur, curIdx) => {
                        const dataIsShown = valView[idx][curIdx];
                        const curAmount = !dataIsShown ? 0 : cur ? 2 : 1
                        return prev + curAmount;
                    }, 0)
                    if (colAmount === 0) {
                        return null;

                    } else {
                        const okNg = okNgView[idx] ? 1 : 0;
                        return (
                            <th className='title' colSpan={colAmount + okNg + 1} key={`dataTHs_${idx}`}>
                                <div>{dataCls}</div>
                            </th>
                        )
                    }
                })
            }
        </React.Fragment>
    );
}

export default DataTHs;